import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	addItemText: {
		id: 'custom-sites-extensions.config-panel.add-card-cta',
		defaultMessage: 'Add card',
		description: 'Button that allows the user to add a new card to their Link Cards extension',
	},
});
